import { Component, OnInit } from '@angular/core';
import { AuthDialogService } from 'src/app/nutrigenic/services/auth/auth-dialog.service';
import { HomeService } from 'src/app/nutrigenic/services/home/home.service';

@Component({
  selector: 'app-auth-dialogs',
  templateUrl: './auth-dialogs.component.html',
  styleUrls: ['./auth-dialogs.component.scss']
})
export class AuthDialogsComponent implements OnInit {
  loginPopupVisibility = false;
  signUpPopupVisibility = false;
  forgotPasswordPopupVisibility = false;
  signupDone = false;
  userId = 0;
  isWebView = false;

  constructor(
    private authDialogService: AuthDialogService,
    private homeService: HomeService
  ) {}

  ngOnInit(): void {
    this.authDialogService.showLogin$.subscribe(() => {
      this.loginPopupVisibility = true;
    });

    this.checkWebView();
  }

  showLogin() {
    this.signUpPopupVisibility = false;
    this.forgotPasswordPopupVisibility = false;
    this.loginPopupVisibility = true;
  }

  showSignup() {
    this.loginPopupVisibility = false;
    this.signUpPopupVisibility = true;
  }

  showForgotPassword() {
    this.loginPopupVisibility = false;
    this.forgotPasswordPopupVisibility = true;
  }

  showConfirmation(userId: number) {
    this.userId = userId;
    this.signUpPopupVisibility = false;
    this.signupDone = true;
  }

  checkWebView() {
    var userAgent = window.navigator.userAgent.toLowerCase(),
        safari = /safari/.test(userAgent),
        ios = /iphone|ipod|ipad/.test(userAgent);

    if (ios) {
      this.isWebView = !safari;
    } else {
      this.homeService.checkWebView().subscribe(res => {
        this.isWebView = res.body.webview !== 0;
      });
    }
  }

}
